// Import model
import { StartCompanyAddNoteRequest } from '../models/StartCompanyAddNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartCompanyAddNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class StartCompanyAddNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a StartCompanyAddNoteRequest instance
   */
  static deserialize(json: string): StartCompanyAddNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartCompanyAddNoteRequest instance
   */
  static fromObject(obj: any): StartCompanyAddNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartCompanyAddNoteRequest');
    }


    const instance: StartCompanyAddNoteRequest = {
      content: obj['Content'] as string | undefined,
      name: obj['Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartCompanyAddNoteRequest instances
   */
  static deserializeArray(json: string): StartCompanyAddNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartCompanyAddNoteRequest instance to a JSON string
   */
  static serialize(instance: StartCompanyAddNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartCompanyAddNoteRequest instance to a plain object
   */
  static toObject(instance: StartCompanyAddNoteRequest): any {
    return {
      'Content': instance.content,
      'Name': instance.name,
    };
  }

  /**
   * Serializes an array of StartCompanyAddNoteRequest instances to a JSON string
   */
  static serializeArray(instances: StartCompanyAddNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
